/**
 * Get the badge color for a template status.
 *
 * @param status - template status
 * @returns badge color
 */
export const getStatusBadgeColor = (
  status?: string,
): "success" | "neutral" | "action" => {
  let statusColor: "success" | "neutral" | "action" = "neutral";
  if (status === "active") statusColor = "success";
  else if (status === "deactive") statusColor = "neutral";
  else statusColor = "action";
  return statusColor;
};
